export default function SpecialEventStatus(type) {
  switch (type.toLowerCase()) {
    case "analise":
      return "Sua solicitação foi efetuada e agora aguarda uma proposta da empresa que conterá novas informações futuramente aqui";

    case "análise":
      return "Sua solicitação foi efetuada e agora aguarda uma proposta da empresa que conterá novas informações futuramente aqui";

    case "proposta":
      return "Sua solicitação foi analisada e agora recebeu uma proposta, podendo ser aceita ou recusada por você";

    case "aprovado":
      return "Está proposta foi aceita, agora basta aguardar a execução do acordo";

    case "recusado":
      return "Está evento teve sua última proposta rejeitada";

    case "rejeitado":
      return "Este evento especial foi rejeitado, logo sua solicitação foi inativada";

    case "cancelado":
      return "Este evento esta cancelado e não recebe mais propostas como também não pode ser aprovado ou alterado";
  }
}
